import { render, staticRenderFns } from "./FormCliente.vue?vue&type=template&id=1acbf616"
import script from "./FormCliente.vue?vue&type=script&lang=js"
export * from "./FormCliente.vue?vue&type=script&lang=js"
import style0 from "./FormCliente.vue?vue&type=style&index=0&id=1acbf616&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports